import { ref, onMounted } from "vue";
import { useRest } from "@/composables/useRest";

export function useProsecutorData() {
  const prosecutorUserTypes = ref([]);

  onMounted(async () => {
    const { get } = useRest();
    const url =
      process.env.VUE_APP_BACKEND_ENVIRONMENT + "/parametros/tipo-usuario?TipoUsuarioPadre=Fiscal";
    const result = await get({ url });
    const prosecutorUserTypesNames = [];
    result.data.data.forEach((userType) => {
      prosecutorUserTypesNames.push(userType.Nombre);
    });
    prosecutorUserTypes.value = prosecutorUserTypesNames;
  });

  return {
    prosecutorUserTypes,
  };
}
